class CollectionFilters extends HTMLElement {
  constructor () {
    super()
    this.activeFilter = null
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    this.resetOutsideClick = this.resetOutsideClick.bind(this)
    this.setupListeners = this.setupListeners.bind(this)
  }

  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    this.querySelectorAll('.js-filter-open').forEach(header => {
      header.addEventListener('click', this.toggleFilter.bind(this))
    })
    document.addEventListener('click', this.handleOutsideClick)
  }

  resetOutsideClick () {
    const activeFilter = document.querySelector('.collection__filters__single__list.is-active')
    if (!activeFilter) { return }

    this.activeFilter = activeFilter
    document.removeEventListener('click', this.handleOutsideClick)
    document.addEventListener('click', this.handleOutsideClick)
  }

  toggleFilter (event) {
    event.stopPropagation()

    const header = event.currentTarget
    const filterList = header.nextElementSibling

    if (filterList && filterList.classList.contains('collection__filters__single__list')) {
      if (this.activeFilter && this.activeFilter !== filterList) {
        this.activeFilter.classList.remove('is-active')

        const previousHeader = this.activeFilter.previousElementSibling
        if (previousHeader && previousHeader.classList.contains('js-filter-open')) {
          previousHeader.classList.remove('is-active')
        }
      }

      const isActive = filterList.classList.toggle('is-active')
      header.classList.toggle('is-active', isActive)

      this.activeFilter = isActive ? filterList : null
    }
  }

  handleOutsideClick (event) {
    if (this.activeFilter) {
      if (!this.contains(event.target)) {
        this.activeFilter.classList.remove('is-active')

        const previousHeader = this.activeFilter.previousElementSibling
        if (previousHeader && previousHeader.classList.contains('js-filter-open')) {
          previousHeader.classList.remove('is-active')
        }

        this.activeFilter = null
      }
    }
  }
}

customElements.define('collection-filters', CollectionFilters)
